// Auto-generated per-query builders for ProposalBatch
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ProposalBatchReadAPI, ProposalBatchWriteAPI, ProposalBatchReadAPISchema, ProposalBatchWriteAPISchema } from '../types/proposalbatch';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, ChangeProposalInBatch, HasAttribute, HasAttributeValue, HasDerivedValue, Mentions, ProposalBatchFromChangeImpact, ProposalBatchOfProject } from '../../relationships/relationship';

import { ChangeProposal } from './changeproposal';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';
import { Project } from './project';
import { ChangeImpact } from './changeimpact';





// Builder chain for query: rflp-proposal-batch-by-id

export interface RflpProposalBatchByIdBuilder_0 {
  get(id: string): RflpProposalBatchByIdBuilder_1;
  filter(conditions: { id: string }): RflpProposalBatchByIdBuilder_1;
}

export interface RflpProposalBatchByIdBuilder_1 {
  all(): Promise<ProposalBatch[]>;
  first(): Promise<ProposalBatch | null>;
  get(): Promise<ProposalBatch[]>;
  execute(): Promise<ProposalBatch[]>;
}


// Union of all query entry points
export type ProposalBatchQueryBuilder = RflpProposalBatchByIdBuilder_0;

// Available query names for .setQuery()
export type ProposalBatchQueryNames = "rflp-proposal-batch-by-id";

// Type narrowing for .setQuery()
export type ProposalBatchBuilderForQuery<Q extends ProposalBatchQueryNames> =
  Q extends "rflp-proposal-batch-by-id" ? RflpProposalBatchByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ProposalBatchInstanceQueryResult<Q extends ProposalBatchQueryNames> =
  Q extends "rflp-proposal-batch-by-id" ? RflpProposalBatchByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-proposal-batch-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ProposalBatchQueryNames>(queryName: Q): ProposalBatchBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface ProposalBatch extends Partial<ProposalBatchReadAPI> {}
export class ProposalBatch extends NeoNodeBase<ProposalBatchReadAPI, ProposalBatchWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "ProposalBatch";
  static readonly readSchema = ProposalBatchReadAPISchema;
  static readonly writeSchema = ProposalBatchWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    project: { target: "Project", cardinality: "one", isParent: true, relClass: "ProposalBatchOfProject", direction: "out" },
    change_impact: { target: "ChangeImpact", cardinality: "one", isParent: false, relClass: "ProposalBatchFromChangeImpact", direction: "out" },
    proposals: { target: "ChangeProposal", cardinality: "many", isParent: false, relClass: "ChangeProposalInBatch", direction: "out" },
  };

  protected get modelName(): string {
    return 'ProposalBatch';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return ProposalBatch.label;
  }


  constructor(data: Partial<ProposalBatchWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ProposalBatchReadAPI, loadContext?: Record<string, any>): ProposalBatch {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { proposals, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, project, change_impact, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ProposalBatchReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, proposals: proposals, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions, project: project, change_impact: change_impact };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return ProposalBatch.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'proposals', 'ChangeProposal', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    loadOneRelationship(processed, 'project', 'Project', ModelRegistry);
    loadOneRelationship(processed, 'change_impact', 'ChangeImpact', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new ProposalBatch(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): ProposalBatchQueryBuilder {
    return new QueryBuilderImpl('ProposalBatch').filter(conditions) as any;
  }

  static all(): ProposalBatchQueryBuilder {
    return new QueryBuilderImpl('ProposalBatch') as any;
  }

  static async first(): Promise<ProposalBatch | null> {
    const results = await new QueryBuilderImpl('ProposalBatch').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ProposalBatchQueryNames>(queryName: Q): ProposalBatchBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('ProposalBatch');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ProposalBatchQueryNames>(queryName: Q): ProposalBatchInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = ProposalBatch.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'proposals' - Python ORM style (cached)
  get proposals(): RelationshipManager<this, ChangeProposal> {
    return this.getOrCreateRelationshipManager('proposals', () => {
      return new RelationshipManager(this, 'proposals', 'many', ChangeProposalInBatch as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'project' - Python ORM style (cached)
  get project(): RelationshipManager<this, Project> {
    return this.getOrCreateRelationshipManager('project', () => {
      return new RelationshipManager(this, 'project', 'one', ProposalBatchOfProject as typeof Relationship);
    });
  }

  // Relationship manager for 'change_impact' - Python ORM style (cached)
  get change_impact(): RelationshipManager<this, ChangeImpact> {
    return this.getOrCreateRelationshipManager('change_impact', () => {
      return new RelationshipManager(this, 'change_impact', 'one', ProposalBatchFromChangeImpact as typeof Relationship);
    });
  }

}
